import { CAN_SELECT_MULTIPLE, NAME, OPTIONS, REQUIRED } from '../../fields'

export const initialValues = {
  [NAME]: '',
  [CAN_SELECT_MULTIPLE]: false,
  [REQUIRED]: false,
  [OPTIONS]: [{ text: '' }]
}
